import HeroSection from "./heroSection";
import {
    RotateCcw, Gift, Truck, BarChart3, Monitor, Plug, Star, Paintbrush,
    Clock, ShoppingCart, Download, Bell, Undo2, Share2, Sparkles,
    Smartphone, Repeat, MessageCircle, Zap, Layers, Store,
    ArrowUpDown, Percent, Headphones, Scale, BrainCircuit, Crown, Lightbulb,
} from "lucide-react";

export default function ListOfFeatures() {

    const sz = 20;
    const sw = 1.75;

    // TODO: Make pages for each of these
    let featuresList = [
        {
            id: 2,
            title: "Process refunds instantly with store credit",
            description: "Refund any order in full or in part with store credit. Also supports refunding more than the original amount for a better refund experience.",
            tier: "starter",
            icon: <RotateCcw size={sz} strokeWidth={sw} />,
        },
        {
            id: 3,
            title: "Gift cards, discount codes, and custom offers",
            description: "Customers can stack store credit with discount codes, gift cards, promotional codes, and custom offers.",
            tier: "starter",
            icon: <Gift size={sz} strokeWidth={sw} />,
        },
        {
            id: 5,
            title: "Shipping and Sales Tax",
            description: "Customers are able to apply their store credit towards their shipping fees and sales tax during their purchases.",
            tier: "starter",
            icon: <Truck size={sz} strokeWidth={sw} />,
        },
        {
            id: 6,
            title: "Dashboards and granular data tracking",
            description: "Gain realtime insights with comprehensive dashboards and granular data tracking.",
            tier: "starter",
            icon: <BarChart3 size={sz} strokeWidth={sw} />,
        },
        {
            id: 6,
            title: "All platform support",
            description: "Use Pabloo on your computer or on the go.",
            tier: "starter",
            icon: <Monitor size={sz} strokeWidth={sw} />,
        },
        {
            id: 7,
            title: "Direct integrations for Shopify and WooCommerce",
            description: "Pabloo integrates seamlessly with the leading e-commerce platforms.",
            tier: "starter",
            icon: <Plug size={sz} strokeWidth={sw} />,
        },
        {
            id: 8,
            title: "Loyalty program for north star metrics",
            description: "The Pabloo loyalty program incentivizes customer sign-ups, referrals, and purchases.",
            tier: "starter",
            icon: <Star size={sz} strokeWidth={sw} />,
        },
        {
            id: 9,
            title: "White labeled and customizable",
            description: "Customizable views to perfectly match your shop's theme and branding, ensuring a flawless experience across all devices.",
            tier: "starter",
            icon: <Paintbrush size={sz} strokeWidth={sw} />,
        },


        {
            id: 1,
            title: "Unlimited deposits, unlimited withdraws",
            description: "Simple, flat-rate pricing. No hidden fees per order.",
            tier: "managed",
            icon: <ArrowUpDown size={sz} strokeWidth={sw} />,
        },
        {
            id: 4,
            title: "Credit expiration and product exclusion",
            description: "Maintain control over your store credit program by establishing expiration timelines and defining any product exclusions.",
            tier: "growth",
            icon: <Clock size={sz} strokeWidth={sw} />,
        },
        {
            id: 4,
            title: "Full Checkout Support",
            description: "Supports Shopify Checkout, draft orders, and Wholesale.",
            tier: "growth",
            badge: "",
            icon: <ShoppingCart size={sz} strokeWidth={sw} />,
        },
        {
            id: 14,
            title: "Export data locally",
            description: "All store credit data can be saved locally for further analysis and integration with downstream applications.",
            tier: "growth",
            icon: <Download size={sz} strokeWidth={sw} />,
        },
        {
            id: 13,
            title: "Email & SMS notifications",
            description: "Customers are kept informed every time their store credit is added, deducted, or earn cashback.",
            tier: "growth",
            icon: <Bell size={sz} strokeWidth={sw} />,
        },
        {
            id: 15,
            title: "Revert any completed transaction",
            description: "Handles any error you make when making a deposit or withdraw. Allows you revert store credit changes, including purchases.",
            tier: "growth",
            icon: <Undo2 size={sz} strokeWidth={sw} />,
        },
        {
            id: 17,
            title: "Opt-in affiliate program",
            description: "Each participating customer has an affiliate link; a portion of each sale generated through the link goes back to the affiliate.",
            tier: "growth",
            icon: <Share2 size={sz} strokeWidth={sw} />,
        },
        {
            id: 19,
            title: "Interactive data with Pabloo AI chat",
            description: "Ask your data anything with our AI assistant.",
            tier: "growth",
            icon: <Sparkles size={sz} strokeWidth={sw} />,
        },
        {
            id: 1,
            title: "Unlimited Cashback activities",
            description: "Run cashback across every product, every customer, and every campaign — no caps, no throttling, no extra fees.",
            tier: "managed",
            badge: "most_used",
            image: "",
            icon: <Percent size={sz} strokeWidth={sw} />,
        },
        {
            id: 2,
            title: "Cash App & Venmo Transfers",
            description: "Customers can purchase store credit directly from Cash App or Venmo account.",
            tier: "growth",
            badge: "new",
            icon: <Smartphone size={sz} strokeWidth={sw} />,
        },
        {
            id: 5,
            title: "Recurring Deposits",
            description: "Customer(s) recieve store credit on a recurring basis.",
            tier: "growth",
            badge: "",
            icon: <Repeat size={sz} strokeWidth={sw} />,
        },
        {
            id: 6,
            title: "In-App Chat Support",
            description: "Get access to 24/7 support chat from within the app.",
            tier: "growth",
            badge: "",
            icon: <MessageCircle size={sz} strokeWidth={sw} />,
        },
        {
            id: 8,
            title: "Purchase Triggers",
            description: "Engage with customers that exhibit purchase behavior, and need a little convincing.",
            tier: "growth",
            badge: "",
            icon: <Zap size={sz} strokeWidth={sw} />,
        },
        {
            id: 9,
            title: "Templates & Customer Segments",
            description: "Create default templates to use for store credit activities and build customer segments.",
            tier: "growth",
            badge: "",
            icon: <Layers size={sz} strokeWidth={sw} />,
        },
        {
            id: 10,
            title: "Shopify POS",
            description: "Use store credit within the Shopify POS.",
            tier: "growth",
            badge: "",
            icon: <Store size={sz} strokeWidth={sw} />,
        },

        {
            id: 12,
            title: "Customer support assistant",
            description: "A dedicated customer support assistant will work closely with you to understand your needs.",
            tier: "managed",
            icon: <Headphones size={sz} strokeWidth={sw} />,
        },
        {
            id: 16,
            title: "Legal currency retailing",
            description: "Your business can legally sell store credit to customers, offering customers flexible payment options and fostering long-term brand engagement.",
            tier: "managed",
            icon: <Scale size={sz} strokeWidth={sw} />,
        },
        {
            id: 18,
            title: "AI Abandoned cart solution",
            description: "Recover lost sales with our AI-powered abandoned cart solution.",
            tier: "managed",
            icon: <BrainCircuit size={sz} strokeWidth={sw} />,
        },
        {
            id: 20,
            title: "AI tool to reengage dormant customers",
            description: "Analyzes expected Customer Lifetime Value (CLTV) to determine the ideal store credit amount to gift each customer, driving repeat purchases within 60 days and optimizing long-term customer value.",
            tier: "managed",
            icon: <Sparkles size={sz} strokeWidth={sw} />,
        },
        {
            id: 1,
            title: "Unlimited membership subscribers",
            description: "Grow your subscriber base without a ceiling. No matter how large your community gets, every member is fully supported.",
            tier: "managed",
            badge: "",
            icon: <Crown size={sz} strokeWidth={sw} />,
        },
    ]

    const TIER_META = {
        starter:  { label: "Starter",         bg: "#f0fdf4", color: "#16a34a", dot: "#16a34a" },
        growth:   { label: "Growth",          bg: "#faf2eb", color: "#92400e", dot: "#d97706" },
        managed:  { label: "Managed Economy", bg: "#fdf4ff", color: "#7e22ce", dot: "#a855f7" },
    };

    return (
        <div>
            <HeroSection />

            <div id="body" style={{ background: "#faf2eb" }}>
                <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "72px 32px" }}>

                    <div style={{ marginBottom: "48px" }}>
                        <p style={{ fontSize: "0.75rem", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: "#16a34a", marginBottom: "12px" }}>
                            Platform
                        </p>
                        <h2
                            id="features"
                            style={{ fontSize: "clamp(1.5rem, 3vw, 2rem)", fontWeight: 700, color: "#2f2f2f", margin: 0, letterSpacing: "-0.02em" }}
                        >
                            What the platform does
                        </h2>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        {featuresList.map((feature, i) => (
                            <div key={i}>{cellView(feature.title, feature.description, feature.tier, feature.icon)}</div>
                        ))}
                        {cellView("Request a feature", "Submit a request for a feature or integration.", "starter", <Lightbulb size={sz} strokeWidth={sw} />)}
                    </div>
                </div>
            </div>
        </div>
    )

    function cellView(title, description, tier, icon) {
        const meta = TIER_META[tier] || TIER_META.starter;
        return (
            <div
                style={{
                    background:    "#ffffff",
                    border:        "1px solid #e9e4dc",
                    borderRadius:  "16px",
                    padding:       "24px",
                    display:       "flex",
                    flexDirection: "column",
                    gap:           "16px",
                    height:        "100%",
                    transition:    "box-shadow 0.2s",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 4px 20px rgba(0,0,0,0.07)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "none"; }}
            >
                {/* Icon */}
                {icon && (
                    <div
                        style={{
                            width:          "40px",
                            height:         "40px",
                            borderRadius:   "10px",
                            background:     meta.bg,
                            display:        "flex",
                            alignItems:     "center",
                            justifyContent: "center",
                            color:          meta.dot,
                            flexShrink:     0,
                        }}
                    >
                        {icon}
                    </div>
                )}

                {/* Title + tier badge */}
                <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "12px" }}>
                    <h3 style={{ fontSize: "0.9375rem", fontWeight: 600, color: "#2f2f2f", margin: 0, lineHeight: 1.4 }}>
                        {title}
                    </h3>
                    <span
                        style={{
                            display:       "inline-flex",
                            alignItems:    "center",
                            gap:           "5px",
                            flexShrink:    0,
                            padding:       "3px 10px",
                            borderRadius:  "99px",
                            fontSize:      "0.7rem",
                            fontWeight:    700,
                            letterSpacing: "0.04em",
                            background:    meta.bg,
                            color:         meta.color,
                            whiteSpace:    "nowrap",
                        }}
                    >
                        <span style={{ width: "5px", height: "5px", borderRadius: "50%", background: meta.dot, display: "inline-block", flexShrink: 0 }} />
                        {meta.label}
                    </span>
                </div>

                {description ? (
                    <p style={{ fontSize: "0.875rem", color: "#7f7e7c", lineHeight: 1.6, margin: 0 }}>
                        {description}
                    </p>
                ) : null}
            </div>
        )
    }
}
